<template lang="html">

    <div class="wrapper margin-menu -area-personal column-center">

        <div class="contenedor-formulario">

            <h1 class="title-intro">Mi usuario</h1>

            <h2>Datos personales</h2>

            <form @submit.prevent="validate">

                <p>{{user.name}}</p>
                <p>{{user.email}}</p>

                <!-- <div class="contenedor-input">
                    <input type="text" class="input-text" v-validate="'required'" v-model="user.name" name="name"
                        :placeholder="$t('formulario.nombre')+'*'" />
                    <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{
                        errors.first('name') }}</span>
                </div>

                <div class="contenedor-input">
                    <input type="text" class="input-text" v-validate="'required'" v-model="user.email" name="email"
                        :placeholder="$t('formulario.email')+'*'" />
                    <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{
                        errors.first('email') }}</span>
                </div> -->



                <!-- <div class="contenedor-input">
                    <input type="password" class="input-text" v-validate="'required|min:8'" ref="password"
                        v-model="data.password" name="password" :placeholder="$t('formulario.password')+'*'" />
                    <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{
                        errors.first('password') }}</span>
                </div>

                <div class="contenedor-input">
                    <input type="password" class="input-text" v-model="data.password_confirmation"
                        v-validate="'required|min:8|confirmed:password'" data-vv-as="password"
                        name="password_confirmation" :placeholder="$t('formulario.password_confirmation')+'*'" />
                    <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{
                        errors.first('password_confirmation') }}</span>
                </div> -->

                <!-- <button class="btn red with-border" :loading="view.loading">Guardar</button> -->

            </form>

            <h2>Mis tarjetas</h2>

            <div class="cards-container">

                <div class="card-list" v-if="cards.length != 0">
                    <div class="card" v-for="(card,key) in cards">
                        <p><span class="brand">{{card.card.brand}}</span> que termina en {{card.card.last4}}</p>
                        <a @click="eraseCard(card.id)" class="erasecard" :loading="view.loadingerase">Borrar</a>
                    </div>
                </div>

                <div class="contenedor-input" v-show="view.showaddCard">
                    <label for="card-element">Nueva tarjeta</label>
                    <div id="card-element"></div>
                    <div class="contenedor-boton row-start">
                        <a class="btn red xs" :loading="view.loadingaddCard" @click="validateBeforeSubmit">Añadir</a>
                    </div>
                    4000002500003155
                </div>

                <a v-if="!!!view.showaddCard" @click="view.showaddCard = true" class="showaddcard"><span>+</span> Añadir
                    tarjeta</a>

            </div>

            <h2>Mis suscripciones</h2>
            <div class="subscriptions-list">
                <div class="suscription" v-for="(sus,key) in subscriptions">
                    <p :canceled="sus.status">
                        {{(sus.type == 1) ? 'Mensual' : 'Anual'}} - {{sus.amount}}€
                    </p>
                    <div v-if="sus.status != 'canceled'">
                        <router-link class="modify" :to="$t('enlaces.modificarsuscripcion')">Modificar</router-link>
                        <a class="erase" @click="requestEraseSuscripcion" :loading="view.loadingerasesus">Cancelar</a>
                    </div>
                </div>
            </div>
            <router-link :to="$t('enlaces.crearsuscripcion')" class="showaddcard"><span>+</span>Crear suscripción
            </router-link>


            <div class="logout">
                <a @click="logout" class="logout">Cerrar sesión</a>
            </div>

        </div>
    </div>

</template>

<script lang="js">

    import VeeValidate from 'vee-validate';
    import { mapActions } from 'vuex';

    export default {
        name: 'mi-perfil',
        mounted() {
            setTimeout(e => {
                this.getuser();
            }, 100)

            this.includeStripe('js.stripe.com/v3/', function () {
                this.configureStripe();
            }.bind(this));
        },
        data() {
            return {
                user: {},
                cards: '',
                stripeAPIToken: 'pk_live_51Iw1iqIjMOewFaa7cMvytnq4Q0pEXIjOHKPCZzHIL5LdlFWLbqL0nED6zCmYuJN5i4kf4qiUgALNWoHtwaZ5kHbe00iZ1sb2Xv',
                stripe: '',
                elements: '',
                cardvalid: false,
                card: '',
                client_secret: '',
                subscriptions: '',
                view: {
                    clicked: false,
                    loading: false,
                    showaddCard: false,
                    loadingaddCard: false,
                    loadingerase: false,
                    loadingerasesus: false
                }
            }
        },
        methods: {
            ...mapActions(['requestuser', 'requestLogout', 'requestcards', 'makeIntentSave', 'saveCard', 'requesteraseCard', 'getSubscriptions', 'deleteSubscriptions']),
            includeStripe(URL, callback) {
                let documentTag = document, tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];
                object.src = '//' + URL;
                if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },
            configureStripe() {

                this.stripe = Stripe(this.stripeAPIToken);
                this.elements = this.stripe.elements();
                this.card = this.elements.create(
                    'card',
                    {
                        style: {
                            base: {
                                fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                                fontSize: '16px',
                                fontSmoothing: 'antialiased',
                                ':-webkit-autofill': {
                                    color: '#fce883',
                                },
                                '::placeholder': {
                                    color: '#64686b',
                                },
                            },
                        },
                    }
                );
                this.card.mount('#card-element');


                this.card.on('change', event => {

                    if (event.complete) {
                        this.cardvalid = true;
                        this.errormessage = '';
                    } else if (event.error) {
                        this.errormessage = event.error.message;
                    } else if (!!!event.error) {
                        this.errormessage = '';
                    }
                });
            },
            validateBeforeSubmit: function () {
                this.clicked = true;
                this.$validator.validateAll().then(canSend => {
                    if (this.cardvalid) {
                        this.view.loadingaddCard = true;
                        this.makeIntentSave().then(r => {
                            this.client_secret = r;
                            this.validateCard(r);
                        })
                    }
                });
            },
            validateCard(client_secret) {
                this.stripe.confirmCardSetup(client_secret, {
                    payment_method: {
                        card: this.card,
                        billing_details: { name: this.user.name }
                    }
                }).then(result => {
                    this.saveCard(result.setupIntent).then(r => {
                        if (r) {
                            this.view.loadingaddCard = false;
                            this.view.showaddCard = false;
                            this.cards = '';
                            this.getuser();
                        }
                    });

                }).catch(e => {
                    console.log(e);
                })
            },
            eraseCard(id) {
                this.view.loadingerase = true;
                this.requesteraseCard(id).then(r => {
                    this.view.loadingerase = false;
                    this.getuser();
                })
            },
            getuser() {
                this.requestuser().then(r => {
                    this.user = r;
                });
                this.requestcards().then(r => {
                    this.cards = r;
                });

                this.getSubscriptions().then(r => {
                    this.subscriptions = r;
                    console.log(r);
                });

            },
            logout() {
                this.requestLogout().then(r => {
                    this.$router.push({ name: 'login' })
                });
            },
            requestEraseSuscripcion() {
                this.view.loadingerasesus = true;
                this.deleteSubscriptions().then(r => {

                    this.getSubscriptions().then(r => {
                        this.subscriptions = r;
                    });
                    this.view.loadingerasesus = false;
                })
            }
        }
    }

</script>


<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/area-interna.vue